import { Button, ButtonTheme, IStyleConfig, numberToPrettyString, Preloader } from '@cian/components';
import { plural } from '@cian/utils/lib/shared/plural';
import * as React from 'react';

import { trackGeoSuggestNoResults } from '../../../filters/components/geo_suggest/tracking';
import {
  trackSearchButtonClick,
  trackSearchButtonInAdvancedFilterClick,
  trackSearchButtonWithAdvancedFilterClick,
} from './tracking';
import { ButtonThemeType } from '@cian/components/lib/components/common/buttonLink';

const styles = require('./index.css');

export interface ISearchButtonProps {
  isAdvancedFiltersOpened?: boolean;
  isNewAdvancedFilters?: boolean;
  theme?: ButtonThemeType;
  buttonStyle?: IStyleConfig;
  count: number | undefined;
  loading: boolean;
  nextURL: string | undefined;
  nextQueryString: string | undefined;
  userInput?: string;
  searchButtonVariants?: [string, string, string];
  searchButtonLabelText?: string;
  fullReloadRequired: boolean;
  onClick(): void;
}

export class SearchButton extends React.Component<ISearchButtonProps> {
  public componentDidUpdate(prevProps: ISearchButtonProps) {
    const { count, userInput } = this.props;

    if (count === 0 && userInput && userInput !== prevProps.userInput) {
      /**
       * Отправляем в аналитику то что пользователь выбрал в гео саджесте
       * (кликом мышки/нажатием на enter) и это привело к нулевой выдаче
       * (до нажатия на кнопку найти)
       */
      trackGeoSuggestNoResults(userInput);
    }
  }

  public render() {
    const { buttonStyle, count, loading, theme, searchButtonLabelText = 'Показать объекты' } = this.props;
    const searchButtonVariants: [string, string, string] = this.props.searchButtonVariants || [
      'объект',
      'объекта',
      'объектов',
    ];

    const searchButtonLabel =
      typeof count !== 'undefined'
        ? `${count < 1 ? 'Найдено' : 'Показать'} ` +
          `${numberToPrettyString(count)} ${plural(count, searchButtonVariants)}`
        : searchButtonLabelText;

    return (
      <Button
        buttonStyle={[styles['searchButton'], loading && styles['searchButton--loading'], buttonStyle]}
        theme={theme || ButtonTheme.BLUE_SOLID}
        onClick={this.handleClick}
        disabled={loading}
      >
        {loading && <Preloader size={16} preloaderStyle={styles['searchButton-preloader']} />}
        {searchButtonLabel}
      </Button>
    );
  }

  private handleClick = () => {
    const {
      loading,
      onClick,
      nextQueryString,
      isNewAdvancedFilters,
      isAdvancedFiltersOpened,
      fullReloadRequired,
      nextURL,
    } = this.props;

    if (loading) {
      return;
    }

    const searchString = nextQueryString || '';

    if (isNewAdvancedFilters) {
      trackSearchButtonInAdvancedFilterClick(searchString);
    } else if (isAdvancedFiltersOpened && !isNewAdvancedFilters) {
      trackSearchButtonWithAdvancedFilterClick(searchString);
    } else {
      trackSearchButtonClick(nextQueryString || '');
    }

    if (fullReloadRequired && nextURL) {
      window.location.assign(nextURL);

      return;
    }

    onClick();
  };
}
